import { Logger } from '~/util/logger';
import { ApiKey } from '~/models/Contensis';
import ContensisRepository from '~/repositories/ContensisRepository';

class ApiKeyService {
  private contensis: ContensisRepository;

  keys: ApiKey[] = [];
  error: AppError | null = null;

  constructor(contensis: ContensisRepository) {
    this.contensis = contensis;
  }

  GetKeys = async (): Promise<
    [ApiErrorResponse | null, ApiKey[] | undefined]
  > => {
    Logger.info(`Getting API keys from '${this.contensis.alias}'`);

    let keys;
    [this.error, keys] = await this.contensis.repo.GetApiKeys();
    if (keys) this.keys = keys;

    return [this.error, this.keys];
  };

  CreateKey = async (
    name: string,
    description?: string
  ): Promise<[ApiErrorResponse | null, ApiKey | undefined]> => {
    Logger.info(`Creating API key '${name}'`);
    const [error, key] = await this.contensis.repo.CreateApiKey({
      name,
      description,
      enabled: true,
    });

    if (error) {
      this.error = error;
    }

    if (key) this.keys.push(key);
    return [error, key];
  };

  UpdateKey = async (
    id: string,
    apiKey: Partial<ApiKey>
  ): Promise<[ApiErrorResponse | null, ApiKey | undefined]> => {
    Logger.info(`Updating API key '${apiKey.name}'`);

    await this.contensis.repo.GetApiKeys();
    if (!this.error && this.keys.length > 0) {
      const currentApiKey = this.keys.find((key) => key.id === id) || {};

      const [error, updatedKey] = await this.contensis.repo.UpdateApiKey({
        ...currentApiKey,
        ...apiKey,
      });
      if (error) {
        this.error = error;
      }
      if (updatedKey) {
        this.keys = this.keys.filter((k) => k.id !== id);
        this.keys.push(updatedKey);
      }
      return [error, updatedKey];
    } else {
      return [this.error, undefined];
    }
  };

  RemoveKey = async (
    id: string
  ): Promise<[ApiErrorResponse | null, undefined]> => {
    Logger.info(`Removing API key '${id}'`);
    [this.error] = await this.contensis.repo.DeleteApiKey(id);
    return [this.error, undefined];
  };
}

export default ApiKeyService;
